/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Pagination_Nav_AriaInputs */

const en_directory_pagination_nav_aria = /** @type {(inputs: Directory_Pagination_Nav_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagination`)
};

const zh_directory_pagination_nav_aria = /** @type {(inputs: Directory_Pagination_Nav_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分页`)
};

/**
* | output |
* | --- |
* | "Pagination" |
*
* @param {Directory_Pagination_Nav_AriaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_pagination_nav_aria = /** @type {((inputs?: Directory_Pagination_Nav_AriaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Pagination_Nav_AriaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_pagination_nav_aria(inputs)
	return zh_directory_pagination_nav_aria(inputs)
});
export { directory_pagination_nav_aria as "directory.pagination.nav_aria" }